module.exports = __webpack_public_path__ + "img/COMBO PALM RED.535db69.svg";